<template>
    <el-dialog title="产品丢失" :visible.sync="inLossDialog" width="520px" :before-close="handleDialogClose" :close-on-click-modal="false" class="custom-form-dialog">
        <el-form ref="formData" :rules="formRules" :model="formData" label-position="top">
            <el-form-item label="产品丢失数量" prop="loss_num">
                <el-input size="small" v-model="formData.loss_num" disabled placeholder="剩余入库数量自动带出"></el-input>
            </el-form-item>
            <el-form-item label="产品丢失原因" prop="loss_note">
                <el-input size="small" v-model="formData.loss_note" type="textarea" :rows="6" placeholder="请输入取消原因"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary" :disabled="BtnDisabled" @click.stop="handleDialogConfirm" >确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { approvalSetCateAdd } from "@/api/index.js"
export default {
    name: "in_loss_product",
    props: {
        inLossDialog: {
            type: Boolean,
            default: false
        },
        productInfo: {
            type: Object,
            default: ()=>{}
        },
    },
    data() {
        return {
            BtnDisabled:false,
            formData: {
                loss_num:0,
                loss_note: "",
            },
            formRules: {
                loss_note: [
                    {required: true, message: "请输入产品丢失原因"}
                ]
            },
            userList: []
        }
    },
    created() {
        this.formData.loss_num = Number(this.productInfo.audit_num) - Number(this.productInfo.total_num)
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:inLossDialog", false)
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    this.$emit("update:inLossDialog", false)
                    this.$emit('success',{loss_num: this.formData.loss_num,loss_note: this.formData.loss_note})
                }
            })
        },

    }
}
</script>
